import firebase from 'firebase/compat/app';

import { InsightsConversation } from '../contextProviders/InsightsChatProvider/conversationTypes';

import STORE_CONSTANTS from './constants';

const converter = {
  toFirestore(item: InsightsConversation): firebase.firestore.DocumentData {
    return { ...item };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): InsightsConversation {
    return snapshot.data(options) as InsightsConversation;
  },
};

// Per-user AI Insights chat history: accounts/{accountId}/users/{userId}/
// insightsConversations/{conversationId} (Phase 5).
const getInsightsConversationsRef = ({
  accountId,
  userId,
  db,
}: {
  accountId: string;
  userId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.USERS_COLLECTION)
    .doc(userId)
    .collection(STORE_CONSTANTS.INSIGHTS_CONVERSATIONS_COLLECTION)
    .withConverter(converter);
};

export default getInsightsConversationsRef;
